import type { ReactNode } from "react";
import { motion } from "framer-motion";
import { ProfileToggle } from "./ProfileToggle";
import { useActiveProfile, useProfileStore } from "@/state/profile";
import { cn } from "@/lib/cn";
import { SyncStatus } from "./SyncStatus";
import { setFamilyToken } from "@/lib/auth";

export function Shell({ children }: { children: ReactNode }) {
  const profile = useActiveProfile();
  const soundMuted = useProfileStore((s) => s.soundMuted);
  const toggleSound = useProfileStore((s) => s.toggleSound);

  return (
    <div className="min-h-[100dvh] flex flex-col">
      <header className="safe-pt px-5 pb-3">
        <div className="w-full max-w-3xl mx-auto">
          <div className="flex items-center justify-between">
            <motion.div
              key={profile.id}
              initial={{ scale: 0.9, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              className="flex items-center gap-2 min-w-0"
            >
              <span
                className={cn(
                  "h-10 w-10 rounded-2xl grid place-items-center text-white font-black text-lg shadow-chunk",
                )}
                style={{ background: profile.color }}
                aria-hidden
              >
                {profile.name[0]}
              </span>
              <div className="leading-tight">
                <div className="font-display text-xl">¡Hola, {profile.name}!</div>
                <div className="text-xs text-brand-muted uppercase tracking-widest">
                  Día en marcha
                </div>
              </div>
            </motion.div>

            <div className="flex items-center gap-2">
              <button
                onClick={toggleSound}
                aria-label={soundMuted ? "Activar sonido" : "Silenciar"}
                className="h-10 w-10 rounded-2xl grid place-items-center bg-brand-surface border border-brand-border shadow-chunk text-brand-ink"
              >
                {soundMuted ? "🔇" : "🔊"}
              </button>
              <button
                onClick={() => setFamilyToken(null)}
                aria-label="Cerrar sesión familiar"
                className="h-10 w-10 rounded-2xl grid place-items-center bg-brand-surface border border-brand-border shadow-chunk text-brand-ink"
              >
                ↪
              </button>
            </div>
          </div>

          <div className="mt-4 flex justify-center">
            <ProfileToggle />
          </div>
        </div>
      </header>

      <main className="flex-1 w-full max-w-3xl mx-auto px-5 pb-6">{children}</main>

      <footer className="safe-pb w-full max-w-3xl mx-auto px-5 text-center text-xs text-brand-muted">
        <SyncStatus />
        <div className="mt-1">DuoMatt · español diario</div>
      </footer>
    </div>
  );
}
